export const FETCH_USER = "FETCH_USER";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_INVESTMENTS = "UPDATE_INVESTMENTS";
export const UPDATE_CAREERS = "UPDATE_CAREERS";
export const UPDATE_TWITTER_LINK = "UPDATE_TWITTER_LINK";
